import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ContractDto } from 'src/app/models/contractDto';
import { NotificationType } from 'src/app/models/notification.message';
import { RequestExpressApprovalV } from 'src/app/models/requests/RequestExpressApprovalV';
import { ContractsService } from 'src/app/services/contracts.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-new-express-approval',
  templateUrl: './new-express-approval.component.html',
  styleUrls: ['./new-express-approval.component.css']
})
export class NewExpressApprovalComponent implements OnInit {
  comment:string='';
  id:number=0;

  constructor(private notification: NotificationService,
    private contractsService: ContractsService) 
    { }


   
    @ViewChild('ngNewExpressForm') theForm: any;
  ngOnInit(): void { this.LoadDropDowns(); }

  async LoadDropDowns() {

    let resContracts = await this.contractsService.GetValidContractsforEpressApprovalCreation().toPromise();
    this.Contracts = <ContractDto[]>resContracts.responseData;

  }
  Contracts: ContractDto[] = [];
  contract: any;

  onSubmit() {

    if (this.comment.length==0)
    {
      
      this.notification.sendMessage({
        message: 'Comment is required',
        type: NotificationType.error
      });

      return;

    }
    this.postExpressRequest();
  }

  postExpressRequest(){
    const requestObj: RequestExpressApprovalV = {} as RequestExpressApprovalV;
    requestObj.id=this.contract.id;
    requestObj.message = this.comment

    this.contractsService.requestExpressApproval(requestObj).subscribe({
      next: (data => {
        
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          window.localStorage.clear();
         // this.router.navigate(['signin']);

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
            

        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });






  }
}
